export default "__VITE_ASSET__6d60127d__"